import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Starfield } from "@/components/Starfield";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full px-4 py-3 rounded-xl bg-black/40 border border-amber-500/20 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-amber-400/60";

  return (
    <div className="relative min-h-screen bg-[#08080A] flex items-center justify-center px-5">
      <Starfield />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 glass rounded-3xl p-8 sm:p-10 w-full max-w-md"
        data-testid="admin-login-card"
      >
        <div className="w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-6 mx-auto">
          <Lock className="text-amber-300" size={24} />
        </div>
        <h1 className="font-serif text-3xl text-amber-50 text-center mb-2">Espace Admin</h1>
        <p className="text-slate-400 text-center text-sm mb-8">YoungspiritClub — Gestion du site</p>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <input required type="email" placeholder="Email" data-testid="admin-login-email-input" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" placeholder="Mot de passe" data-testid="admin-login-password-input" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-gradient-to-r from-amber-300 to-yellow-600 text-[#08080A] font-medium hover:scale-[1.02] transition-transform disabled:opacity-60">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
